import styles from './Question.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import { TextAnimator } from '../TextAnimator/TextAnimator';

function Question({ title, initDelay }) {
  const { questionFontSize } = useGetParams();

  const isLong = title?.length > 100;

  return (
    <div
      className={styles.question}
      style={{
        fontSize: isLong
          ? `${0.8 * questionFontSize}rem`
          : `${questionFontSize}rem`,
      }}
    >
      {title && (
        <TextAnimator
          isRepeat={false}
          text={title}
          className={styles.line}
          duration={0.3}
          delay={0.02}
        />
      )}
    </div>
  );
}

export default Question;
